import { Component, For } from "solid-js";
import { Table } from "solid-bootstrap";

export const PaymentsTable: Component<{
  payments: any;
}> = (props) => {

  const headers = ["S.No", "TxnId", "Amount", "Status"];

  return (
    <div class={"form-group ms-3 mb-3 me-4"}>
      <legend class={"pb-3"}>Payments</legend>
      {
        props.payments
          ? props.payments.length > 0
            ? <Table striped bordered hover size="sm">
              <thead>
              <tr>
                <For each={headers}>
                  {(header) => {
                    return (
                      <th>{header}</th>
                    );
                  }}
                </For>
              </tr>
              </thead>
              <tbody>
              <For each={props.payments}>
                {(row, i) => {
                  return (
                    <tr>
                      <td>{i() + 1}</td>
                      <td>{row.transactionId}</td>
                      <td>{row.paymentAmt}</td>
                      <td>{row.status}</td>
                    </tr>
                  );
                }}
              </For>
              </tbody>
            </Table>
            : <div>No payments found</div>
          : <div>Loading Payments...</div>
      }

    </div>

  );
};